import { lazy, Suspense } from "react";
import Page from "@jumbo/shared/Page";
import CuttingMiddleWare from "./middleware/auth/cuttingValidRoute";
import SmokingMiddleWare from "./middleware/auth/smokingValidRoute";
import DyingMiddleWare from "./middleware/auth/dyingValidRoute";
import TappingMiddleWare from "./middleware/auth/tappingValidRoute";
import PressingMiddleWare from "./middleware/auth/pressingValidRoute";
import FinishingMiddleWare from "./middleware/auth/finishingValidRoute";

// ✅ Lazy imports
const FactoryCuttingList = lazy(() => import("app/pages/Factory/Cutting/List"));
const CreateCutting = lazy(() => import("app/pages/Factory/Cutting/Add"));

const FactorySmokingList = lazy(() => import("app/pages/Factory/Smoking/List"));
const CreateSmoking = lazy(() => import("app/pages/Factory/Smoking/Create"));
const CreateGroupSmoking = lazy(() => import("app/pages/Factory/Smoking/Create/createGroupSmoking"));

const FactoryDyingList = lazy(() => import("app/pages/Factory/Dying/List"));
const CreateDying = lazy(() => import("app/pages/Factory/Dying/Create"));
const CreateGroupDying = lazy(() => import("app/pages/Factory/Dying/Create/createGroupDying"));

const FactoryTappingList = lazy(() => import("app/pages/Factory/Tapping/List"));
const CreateTapping = lazy(() => import("app/pages/Factory/Tapping/Create"));

const FactoryPressingList = lazy(() => import("app/pages/Factory/Pressing/List"));

const FactoryFinishingList = lazy(() => import("app/pages/Factory/Finishing/List"));
const CreateFinishing = lazy(() => import("app/pages/Factory/Finishing/Create"));

export const factoryRoutes = [
  {
    middleware: [{ element: CuttingMiddleWare, fallbackPath: "/dashboard" }],
    routes: [
      {
        path: "/dashboard/factory/cutting",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={FactoryCuttingList} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/factory/add-cutting",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={CreateCutting} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },
  {
    middleware: [{ element: SmokingMiddleWare, fallbackPath: "/dashboard" }],
    routes: [
      {
        path: "/dashboard/factory/smoking",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={FactorySmokingList} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/factory/smoking/create-smoking-individual",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={CreateSmoking} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/factory/smoking/create-smoking-group",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={CreateGroupSmoking} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },
  {
    middleware: [{ element: DyingMiddleWare, fallbackPath: "/dashboard" }],
    routes: [
      {
        path: "/dashboard/factory/dying",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={FactoryDyingList} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/factory/dying/create-dying-individual",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={CreateDying} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/factory/dying/create-dying-group",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={CreateGroupDying} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },
  {
    middleware: [{ element: TappingMiddleWare, fallbackPath: "/dashboard" }],
    routes: [
      {
        path: "/dashboard/factory/tapping",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={FactoryTappingList} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/factory/add-tapping",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={CreateTapping} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },
  {
    middleware: [{ element: PressingMiddleWare, fallbackPath: "/dashboard" }],
    routes: [
      {
        path: "/dashboard/factory/pressing",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={FactoryPressingList} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },
  {
    middleware: [{ element: FinishingMiddleWare, fallbackPath: "/dashboard" }],
    routes: [
      {
        path: "/dashboard/factory/finishing",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={FactoryFinishingList} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/factory/add-finishing",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={CreateFinishing} layout={"vertical-default"} />
          </Suspense>
        ),
      },
    ],
  },
];
